// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { type APIPromise, APIResource, type FetchParams } from "../../core";

import type {
  DoingBusinessAsLegacy,
  ErrorBody,
  ErrorForbidden,
  MerchantAccount,
  MerchantProfileLegacy,
  PersonalProfileLegacy,
} from "../../types";
export type GetAccountQueryParams = {
  "include[]"?: (
    | "settings"
    | "doing_business_as"
    | "bank_accounts"
    | "app_settings"
    | "country_details"
  )[];
};

export class MerchantResource extends APIResource {
  /**
   * Returns user profile information.
   */
  get(
    query?: GetAccountQueryParams,
    params?: FetchParams,
  ): APIPromise<MerchantAccount, ErrorBody> {
    return this._client.get<MerchantAccount, ErrorBody>({
      path: `/v0.1/me`,
      query,
      ...params,
    });
  }

  /**
   * Retrieves personal profile data.
   */
  getPersonalProfile(
    params?: FetchParams,
  ): APIPromise<PersonalProfileLegacy, ErrorBody> {
    return this._client.get<PersonalProfileLegacy, ErrorBody>({
      path: `/v0.1/me/personal-profile`,
      ...params,
    });
  }

  /**
   * Retrieves merchant profile data.
   */
  getMerchantProfile(
    params?: FetchParams,
  ): APIPromise<MerchantProfileLegacy, ErrorBody | ErrorForbidden> {
    return this._client.get<MerchantProfileLegacy, ErrorBody | ErrorForbidden>({
      path: `/v0.1/me/merchant-profile`,
      ...params,
    });
  }

  /**
   * Retrieves Doing Business As profile.
   */
  getDoingBusinessAs(
    params?: FetchParams,
  ): APIPromise<DoingBusinessAsLegacy, ErrorBody> {
    return this._client.get<DoingBusinessAsLegacy, ErrorBody>({
      path: `/v0.1/me/merchant-profile/doing-business-as`,
      ...params,
    });
  }
}
